/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { Schema } from '@jalik/schema'

const UserSchema = new Schema({
  email: {
    type: 'string',
    format: 'email'
  },
  enabled: {
    type: 'boolean',
    required: true
  },
  password: {
    type: 'string',
    maxLength: 50
  },
  roleId: {
    type: 'number'
  },
  username: {
    type: 'string',
    maxLength: 50,
    required: true
  }
})

export default UserSchema
